import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';
import { useInstallationContext } from '../../../../../../context/installation';
import {
  OnRequestAckReceivedSubscription,
  OnRequestAckReceivedSubscriptionVariables,
  OnSensorValueChangeSubscription,
  OnSensorValueChangeSubscriptionVariables,
  RequestAckPayload,
  SensorValueChangePayload,
} from '../../../../../../data-access/gql-types/graphql';
import {
  ON_REQUEST_ACK_RECEIVED,
  ON_SENSOR_VALUE_CHANGE,
} from '../../../../../../data-access/subscriptions/lavva-devices';
import { useUpdateCommonLavvaState } from '../common-lavva-state';
import { ChannelSubscriptionParams } from '../types';
import { useLavvaDeviceSensorUpdate } from './update';

export const useSensorSubscriptions = ({ channelId }: ChannelSubscriptionParams) => {
  const { updateLavvaSensorState } = useLavvaDeviceSensorUpdate();
  const { onRequestAckReceived } = useUpdateCommonLavvaState();
  const { skipLavvaFetch } = useInstallationContext();
  const { data: sensorChange } = useSubscription<
    OnSensorValueChangeSubscription,
    OnSensorValueChangeSubscriptionVariables
  >(ON_SENSOR_VALUE_CHANGE, {
    variables: { channelId },
    skip: skipLavvaFetch,
  });
  const { data: ackReceived } = useSubscription<
    OnRequestAckReceivedSubscription,
    OnRequestAckReceivedSubscriptionVariables
  >(ON_REQUEST_ACK_RECEIVED, {
    variables: { channelOrDeviceId: channelId },
    skip: skipLavvaFetch,
  });

  useEffect(() => {
    if (sensorChange) updateLavvaSensorState(sensorChange.onSensorValueChange as SensorValueChangePayload);
  }, [sensorChange]);

  useEffect(() => {
    if (ackReceived) onRequestAckReceived(ackReceived.onRequestAckReceived as RequestAckPayload);
  }, [ackReceived]);
};
